query getBonusGameIds {
  userPromo {
    activeStep {
      id
      gameIdsList
    }
  }
}
